<template>
    <div class="top-table-filter-container">
        <!-- Десктопная версия -->
        <div class="d-none d-md-block">
            <div class="green-filter d-flex" v-if="!showSalesFilter && !showTransportFilter">
                <span 
                    v-for="(item, index) in filteredGreenFilterMenu" 
                    :key="index" 
                    :class="`mr-3 ${item.active ? 'green-link active' : 'green-link'}`" 
                    @click="changeActive(index)"
                >
                    {{ item.title }}
                </span>

                <b-button
                    v-if="activeIndex != 2"
                    title="Открыть сейлзовый фильтр"
                    size="sm"
                    :variant="showSalesFilter ? 'primary' : 'secondary'"
                    id="filter-sales_off"
                    @click="showSalesFilter=!showSalesFilter"
                >
                    <b-icon icon="filter-square" scale="1" aria-label="Фильтр продаж"></b-icon>
                </b-button>

                <b-button
                    v-if="activeIndex == 2"
                    title="Открыть фильтр по транспортным компаниям"
                    size="sm"
                    :variant="showTransportFilter ? 'primary' : 'secondary'"
                    id="filter-ts_off"
                    @click="showTransportFilter=!showTransportFilter"
                >
                    <b-icon icon="filter-square" scale="1" aria-label="Фильтр по транспортным компаниям"></b-icon>
                </b-button>

                <template v-if="isCanSeeEnrichment">
                    <router-link 
                        to="/companies/dadata-check"
                        title="Открыть страницу по автоматическим проверкам данных компаний"
                        size="sm"
                        :variant="'secondary'"
                        class="ml-3"
                    >
                        <b-icon icon="briefcase" scale="1" aria-label="Открыть страницу по автоматическим проверкам данных компаний"></b-icon>
                    </router-link>
                </template>
            </div>
            <div class="green-filter d-flex" v-if="showSalesFilter && activeIndex != 2">
                <b-button
                    title="Закрыть сейлзовый фильтр"
                    size="sm"
                    class="mr-3"
                    :variant="showSalesFilter ? 'primary' : 'secondary'"
                    id="filter-sales_on"
                    @click="showSalesFilter=!showSalesFilter"
                >
                    <b-icon icon="filter-square" scale="1" aria-label="Фильтр продаж"></b-icon>
                </b-button>
                <span 
                    v-for="(item, index) in greenSubFilterMenu" 
                    :key="index" 
                    :class="`mr-3 ${item.active ? 'green-link active' : 'green-link'}`" 
                    @click="changeSubmenuActive(index)"
                >
                    {{ item.title }}
                </span>
            </div>
            <div class="d-flex position-relative" v-if="activeIndex == 2">
                <div v-show="showTransportFilter">
                    <b-button
                        title="Закрыть фильтр по транспортным компаниям"
                        size="sm"
                        class="mr-3"
                        :variant="showTransportFilter ? 'primary' : 'secondary'"
                        id="filter-ts_on"
                        @click="showTransportFilter=!showTransportFilter"
                    >
                        <b-icon icon="filter-square" scale="1" aria-label="Фильтр по транспортным компаниям"></b-icon>
                    </b-button>

                    <FilterByTransportCompanies
                        @startSearch="startSearch"
                        @disableSearch="disableSearch"
                    ></FilterByTransportCompanies>
                </div>
            </div>
        </div>

        <!-- Мобильная версия -->
        <div class="d-flex d-md-none mobile-filter-container">
            <!-- Бургер-меню -->
            <button 
                class="burger-menu-btn"
                @click="toggleMobileMenu"
                :class="{ active: isMobileMenuOpen }"
            >
                <span class="burger-line"></span>
                <span class="burger-line"></span>
                <span class="burger-line"></span>
            </button>

            <!-- Выпадающее меню -->
            <div class="mobile-dropdown" :class="{ show: isMobileMenuOpen }">
                <!-- Основные фильтры -->
                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Тип компаний</h6>
                    <div class="mobile-filter-items">
                        <span 
                            v-for="(item, index) in filteredGreenFilterMenu"
                            :key="index"
                            :class="`mobile-filter-item ${item.active ? 'active' : ''}`"
                            @click="changeActive(index); closeMobileMenu()"
                        >
                            {{ item.title }}
                        </span>
                    </div>
                </div>

                <!-- Сейлзовый фильтр -->
                <div class="mobile-filter-section" v-if="activeIndex != 2">
                    <h6 class="mobile-filter-title">Фильтр продаж</h6>
                    <div class="mobile-filter-items">
                        <span 
                            :class="`mobile-filter-item ${showSalesFilter ? 'active' : ''}`"
                            @click="showSalesFilter = !showSalesFilter"
                        >
                            {{ showSalesFilter ? 'Скрыть фильтр' : 'Показать фильтр' }}
                        </span>
                        
                        <!-- Статусы готовности внутри меню -->
                        <div v-if="showSalesFilter" class="mobile-filter-submenu">
                            <div class="mobile-filter-submenu-items">
                                <span 
                                    v-for="(item, index) in greenSubFilterMenu"
                                    :key="index"
                                    :class="`mobile-filter-item ${item.active ? 'active' : ''}`"
                                    @click="changeSubmenuActive(index); closeMobileMenu()"
                                >
                                    {{ item.title }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Фильтр транспортных компаний -->
                <div class="mobile-filter-section" v-if="activeIndex == 2">
                    <h6 class="mobile-filter-title">Фильтр транспортных компаний</h6>
                    <div class="mobile-filter-items">
                        <span 
                            :class="`mobile-filter-item ${showTransportFilter ? 'active' : ''}`"
                            @click="showTransportFilter = !showTransportFilter; closeMobileMenu()"
                        >
                            {{ showTransportFilter ? 'Скрыть фильтр' : 'Показать фильтр' }}
                        </span>
                    </div>
                </div>

                <!-- Дополнительные действия -->
                <div class="mobile-filter-section" v-if="isCanSeeEnrichment">
                    <h6 class="mobile-filter-title">Дополнительно</h6>
                    <div class="mobile-filter-items">
                        <router-link 
                            to="/companies/dadata-check"
                            class="mobile-filter-item"
                            @click="closeMobileMenu()"
                        >
                            Проверки данных
                        </router-link>
                    </div>
                </div>
            </div>
        </div>


        <!-- Мобильная версия фильтра транспортных компаний -->
        <div class="d-block d-md-none" v-if="activeIndex == 2 && showTransportFilter">
            <div class="mobile-transport-filter">
                <FilterByTransportCompanies
                    @startSearch="startSearch"
                    @disableSearch="disableSearch"
                ></FilterByTransportCompanies>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from "vuex";
    import FilterByTransportCompanies from "@/components/companies/CompanyTableFilterByTransportCompanies";
    import {
        dataHelpers
    } from '@/mixins';

    export default {
        props: {
            api: {type: String, required: true},              // Link on API for table working
        },
        components: {
            FilterByTransportCompanies
        },
        mixins: [
            dataHelpers
        ],        
        data() {
            return {
                isMobileMenuOpen: false,
                activeIndex: 0,
                showSalesFilter: false,
                showTransportFilter: false,
                additionalParameter: '',
                greenFilterMenu: [
                    {title: "Все клиенты", active: true, is_transport_company: false},
                    {title: "Мои клиенты", active: false, where_iam_sales_manager: true, is_transport_company: false},
                    {title: "Транспортные компании", active: false, is_transport_company: true},
                ],
                greenSubFilterMenu: [
                    {title: "Все", active: true},
                    {title: "Готов сейчас", active: false, salesFilter: true},
                    {title: "Готов но позже", active: false, salesFilter: true},
                    {title: "Не готов", active: false, salesFilter: true},
                ],
            }
        },
        computed: {
            ...mapGetters("auth", ["currentUser"]),

            isCanSeeEnrichment() {
                return this.currentUser.role.includes('administrator');
                        // || 
                        // this.currentUser.role.includes('president') || 
                        // this.currentUser.role.includes('head-accountant') || 
                        // this.currentUser.role.includes('sales-head-manager') || 
                        // this.currentUser.role.includes('TO-head-manager') || 
                        // this.currentUser.role.includes('logistics-head-manager') || 
                        // this.currentUser.role.includes('logistics-multim-head-manager') || 
                        // this.currentUser.role.includes('b2c-head-manager') || 
                        // this.currentUser.role.includes('lawyer-head-manager') || 
                        // this.currentUser.role.includes('hr-head-manager');
            },

            isSalesManager() {
                return  this.currentUser.role.includes('sales-manager');
            },

            filteredGreenFilterMenu() {
                if (this.isSalesManager) {
                    return this.greenFilterMenu.filter(item => item.title !== 'Транспортные компании');
                }
                return this.greenFilterMenu;
            },
        },        
        mounted() {
            let savedIndex = this.$store.state.userLocalSettings.filterSettings.companyTable;
            
            // Если пользователь - менеджер продаж и сохраненный индекс указывает на "Транспортные компании"
            if (this.isSalesManager && this.greenFilterMenu[savedIndex] && this.greenFilterMenu[savedIndex].title === 'Транспортные компании') {
                savedIndex = 0; // Переключаемся на "Все клиенты"
            }
            
            // Найдем индекс в отфильтрованном массиве
            const savedItem = this.greenFilterMenu[savedIndex];
            const filteredIndex = this.filteredGreenFilterMenu.findIndex(item => item.title === savedItem.title);
            
            this.changeActive(filteredIndex >= 0 ? filteredIndex : 0);
        },
        methods: {
            changeActive(filteredIndex) {
                let additionalParameter = '';

                // Найдем соответствующий элемент в оригинальном массиве
                const selectedItem = this.filteredGreenFilterMenu[filteredIndex];
                const originalIndex = this.greenFilterMenu.findIndex(item => item.title === selectedItem.title);
                
                this.activeIndex = originalIndex;

                this.$store.dispatch("userLocalSettings/SET_FILTER_SETTINGS", {
                    name: 'companyTable',
                    value: originalIndex
                });

                this.greenFilterMenu.forEach((item, index) => {
                    item.active = false;
                    if (originalIndex == index) {
                        item.active = true;
                        if (item.where_iam_sales_manager) {
                            additionalParameter += '&where_iam_sales_manager=true';
                        }
                        if (item.is_transport_company) {
                            additionalParameter += '&is_transport_company=1&headerName=tableHeadersSupplier';
                        } else {
                            additionalParameter += '&is_transport_company=0';
                        }
                    }
                })
                this.additionalParameter = additionalParameter;
                this.changeSubmenuActive(0, true);
                this.$emit('setFilteringApiParameter', additionalParameter);
            },
            changeSubmenuActive(activeIndex, silenceMode = false) {
                let additionalParameter = this.additionalParameter;

                this.greenSubFilterMenu.forEach((item, index) => {
                    item.active = false;
                    if (activeIndex == index) {
                        item.active = true;
                        if (item.salesFilter) {
                            additionalParameter += `&sales_status_filter=${item.title}`;
                        }
                    }
                })

                if (!silenceMode) {
                    this.$emit('setFilteringApiParameter', additionalParameter);
                }
            },
            startSearch(searchData) {
                this.$emit('setFilteringApiParameter', this.additionalParameter + '&' + this.objectToQueryString(searchData));
                this.showTransportFilter = false;
            },
            disableSearch(value) {
                this.showTransportFilter = false;
            },

            // Методы для мобильного меню
            toggleMobileMenu() {
                this.isMobileMenuOpen = !this.isMobileMenuOpen;
            },

            closeMobileMenu() {
                this.isMobileMenuOpen = false;
            }
        }
    }
</script>